export const getDisplayName = (firstName: string | null | undefined, lastName: string | null | undefined) => {
	return [firstName, lastName].filter(Boolean).join(" ");
};
